export const SC = 'sc';
